import {
    AfterContentInit,
    Component,
    ContentChild,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ModalService } from './modal.service';

@Component({
    selector: 'ft-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css'],
    inputs: [
        'id',
        'datasource',
        'hideOnDone',
        'headerText',
        'headerDescription',
        'doneText',
        'doneVisible',
        'size',
        'footerAlign',
        'cancelVisible',
        'footerVisible',
        'footerCancelText',
        'footerCancelVisible',
        'topButtonVisible',
        'topButtonText',
        // WS5 #10 Stage A (#107): v1 ftModal parity for the audiences
        // `<ft-modal template-type="v2">` shells. v1's modal_v2.html is a bare
        // `<div>[modal-content]</div>` — no chrome, no footer, no close button;
        // the projected content brings its own `.ft-modal` markup. Static
        // attribute binds via the public name alias.
        'templateType: template-type'
    ],
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy, AfterContentInit {
  id: string;
  datasource: any;
  @Output() success: EventEmitter<any> = new EventEmitter();
  @Output() failure: EventEmitter<any> = new EventEmitter();

  @ViewChild('modalForm', {static: false}) modalForm: NgForm;

  headerText = '';
  headerDescription = '';
  doneText = 'Done';
  doneVisible = true;
  size = 'sm';
  footerAlign = 'right';
  cancelVisible = true;
  footerVisible = true;
  footerCancelText = 'Cancel';
  footerCancelVisible = false;
  hideOnDone = true;
  templateType?: string;

  sub: Subscription;
  modalData: object;
  isVisible = false;
  hide: Function;
  show: Function;

  @ContentChild(TemplateRef, {static: false})
  tmpl: TemplateRef<any>;

  @ViewChild('tc', {static: false})
  tcTmpl;

  selectedTemplate: TemplateRef<any>;

  ngOnInit() {
    this.modalService.add(this.id);
    this.sub = this.modalService.onVisibilityChanges
      .pipe(
        filter(val => val.id === this.id),
        tap(val => {
          this.modalData = typeof this.datasource == 'object' ? Object.assign({}, this.datasource) : this.datasource;
          this.isVisible = val.isVisible;
          // v1's ngStrap $modal put `modal-open modal-with-am-fade` on <body>
          // while shown (`.modal-open { overflow: hidden }` kills the page
          // scrollbar — layout-affecting, so required for pixel parity).
          // No ref-counting: the only template-type=v2 shells are the 12
          // audiences modals (one component, one visible at a time).
          if (this.templateType === 'v2') {
            document.body.classList.toggle('modal-open', val.isVisible);
            document.body.classList.toggle('modal-with-am-fade', val.isVisible);
          }
        })
      )
      .subscribe();

    this.show = this.modalService.show.bind(this.modalService, this.id);
    this.hide = this.modalService.hide.bind(this.modalService, this.id);
  }

  done() {
    this.success.emit(this.modalData);
    this.hideOnDone && this.modalService.hide(this.id);
  }

  cancel() {
    this.failure.emit();
    this.modalService.hide(this.id);
  }

  constructor(private modalService: ModalService) {}

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.modalService.remove(this.id);
    if (this.templateType === 'v2' && this.isVisible) {
      document.body.classList.remove('modal-open', 'modal-with-am-fade');
    }
  }

  ngAfterContentInit() {
    this.selectedTemplate = !!this.tmpl ? this.tmpl : this.tcTmpl;
  }
}
